import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
} from '@chakra-ui/react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import { Cross, Stars } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyMedium, TextHeader2 } from 'uiToolkitV1/Typography';

const primaryDrawerWidth = '578px';
const secondaryDrawerWidth = 1134;

const ExitWithoutSavingModal = ({ isSecondaryPanelOpen = false, children }) => {
  const theme = useTheme();

  const isOpen = false;

  const closeModal = () => {};

  return (
    <StyledDrawer isOpen={isOpen} placement="bottom" onClose={closeModal}>
      <DrawerOverlay />
      <StyledDrawerContent width={primaryDrawerWidth}>
        <DrawerHeader py={1} pt={3} px={5} pos="relative">
          <Flex alignItems="center">
            <Stars boxSize="20px" />
            <Box pl={2}>
              <Flex alignItems="center" justifyContent="space-between">
                <TextHeader2 bold>Exit Changes</TextHeader2>
              </Flex>
            </Box>
          </Flex>
          <StyleCloseButton
            variant="filled"
            color="black"
            StartIcon={(props) => <Cross {...props} boxSize="20px" />}
            onClick={closeModal}
          />
        </DrawerHeader>

        <Divider />
        <StyledDrawerBody px={2}>
          <Box ml={3} p={1}>
            <TextBodyMedium>
              Exiting the page would lose you on the recent changes. Are you sure you want to exit?
            </TextBodyMedium>
          </Box>
        </StyledDrawerBody>

        <DrawerFooter borderRadius={8} borderTopWidth="1px" h="72px" backgroundColor={theme.colors.neutral.F5F7F9}>
          <Button sty variant="outlined" mr={4} onClick={closeModal}>
            Go Back to Preferences
          </Button>
          <Button variant="filled" color="red" onClick={closeModal} disabled={false}>
            Exit Preferences
          </Button>
        </DrawerFooter>
        {/* <Flex
              bgColor={theme.colors.surface.F5F7F9}
              alignItems={'center'}
              justifyContent={'flex-end'}
              paddingRight={4}
              position="fixed"
              bottom={0}
              width={'100%'}
              columnGap={4}
              paddingY={3}
            >
              <Button onClick={closeModal} variant="outlined">
                Cancel
              </Button>
  
              <Button onClick={closeModal} disabled={false}>
                Save
              </Button>
            </Flex> */}
      </StyledDrawerContent>
    </StyledDrawer>
  );
};

export default ExitWithoutSavingModal;

const StyledDrawer = styled(Drawer)`
  background-color: white;
`;

const StyledDrawerContent = styled(DrawerContent)`
  height: 26vh;
  width: ${(props) => props.width};

  background-color: white;
  border-radius: 8px;

  position: absolute;
  top: 0;

  margin: auto;

  transition: width 0.375s;
`;

const StyledDrawerBody = styled(DrawerBody)`
  overflow-x: hidden;
`;

const StyledDrawerInnerContent = styled(Box)`
  min-width: 250px;
  max-width: 250px;
`;

const StyleCloseButton = styled(Button)`
  position: absolute;
  left: -14px;
  top: -14px;

  padding: 2px;
  height: 28px;

  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors.neutral.F5F7F9};
`;
